import clsx from 'clsx';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { UILoader } from '@futrli/ui-components';

import { useReportBuilderContext } from '../../report-builder.context';
import { CARD_TYPES, LayoutData } from '../../types';

import styles from './image-card.scss';

interface Props {
  cardData: LayoutData;
}
export const ImageCard = ({ cardData }: Props) => {
  const { uploadedImages, allRequestsFinished } = useReportBuilderContext();
  const img = useMemo(() => uploadedImages.find(img => img.id === cardData[CARD_TYPES.IMAGE]?.id), [
    uploadedImages,
    cardData
  ]);

  return img ? (
    <div className={clsx(styles.imageCard, styles[cardData[CARD_TYPES.IMAGE]?.behavior || 'original'])}>
      <img src={img.s3_url} alt="image-card" />
    </div>
  ) : allRequestsFinished ? (
    <p className={clsx(styles.centeredText)}>
      <FormattedMessage id="reporting.image_not_found" defaultMessage="Image not found" />
    </p>
  ) : (
    <div className={styles.pageCardLoaderContainer}>
      <UILoader />
    </div>
  );
};
